import { InlineGrid, InlineGridProps, Select } from '@shopify/polaris';
import { memo } from 'react';

interface IProps {
  minute: string;
  hour: string;
  setMinute: (value: string) => void;
  setHour: (value: string) => void;
  disabled?: boolean;
  gap?: InlineGridProps['gap'];
}
interface IMinute {
  disabled?: boolean;
  minute: string;
  setMinute: (value: string) => void;
}
interface IHour {
  disabled?: boolean;
  hour: string;
  setHour: (value: string) => void;
}
const MinuteOptions = () => {
  let result = [];
  for (var i = 0; i < 60; i++) {
    if (i < 10) {
      result.push({
        value: '0' + i.toString(),
        label: '0' + i.toString(),
      });
    } else {
      result.push({
        value: i.toString(),
        label: i.toString(),
      });
    }
  }
  return result;
};
const HourOptions = () => {
  let result = [];
  for (var i = 0; i < 24; i++) {
    if (i < 10) {
      result.push({
        value: '0' + i.toString(),
        label: '0' + i.toString(),
      });
    } else {
      result.push({
        value: i.toString(),
        label: i.toString(),
      });
    }
  }
  return result;
};

const Minutes = ({ disabled, minute, setMinute }: IMinute) => {
  return <Select label="" labelHidden options={MinuteOptions()} onChange={setMinute} value={minute} disabled={disabled} />;
};
const Hours = ({ disabled, hour, setHour }: IHour) => {
  return <Select label="" labelHidden options={HourOptions()} onChange={setHour} value={hour} disabled={disabled} />;
};

const TimePicker = ({ gap, disabled, hour, minute, setHour, setMinute }: IProps) => {
  return (
    <InlineGrid columns={2} gap={gap ?? '100'}>
      <Hours disabled={disabled} hour={hour} setHour={setHour} />
      <Minutes disabled={disabled} minute={minute} setMinute={setMinute} />
    </InlineGrid>
  );
};

export default memo(TimePicker);
